<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '../../components/bill_download/ModalFormComponent.vue';

export default {
	name: "bills-table",
	components: {
		ModalFormComponent,
	},
	data() {
		return {
            errors: {},
            form: {
                files: [],
            },
            send: false,
			total: 0,
			no_seal: 0,
			valid: 0,
			complements: 0,
			complements_no_save: 0,
			complements_no_parent: 0,
			saved: 0,
			not_saved: 0,
			no_xml: 0,
			no_company: 0,
			no_provider: 0,
			bill: {},
		}
	},
	async mounted() {
		this.last();
		this.setHeaderTitle('Descarga Facturas');
	},
	created() {

	},
	methods: {
        uploadFilesBill(event) {
            let vm = this;

            let droppedFiles = event.target.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        dragFilesBill(event) {
            let vm = this;

            let droppedFiles = event.dataTransfer.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
        async sendFiles() {
            this.send=true;
			this.total=0;
			this.no_seal=0;
			this.valid=0;
			this.complements=0;
			this.complements_no_save=0;
			this.complements_no_parent=0;
			this.saved=0;
			this.not_saved=0;
			this.no_xml=0;
			this.no_company=0;
			this.no_provider=0;
			var files=[],ind=0,count=0,i=0;
			files[0]=[];
            this.form.files.forEach(function (valor) {
				if(count==20){
					ind++;
					count=0;
					files[ind]=[];
				}
				files[ind][count++]=valor;
            });

            let _endpoint = `/bill_download`;

			while(i<=ind){
				const data_form = new FormData();
				files[i].forEach(function (valor2, index2) {
					data_form.append('xmls[' + index2 + ']', valor2);
				})
				try {
					let { data } = await request.postMedia(_endpoint, data_form)
					if (!data.ok) {
						this.$swal({
							icon: 'error',
							title: 'No se pudieron cargar todas las facturas',
							text: data.errors.xmls[0]
						});
					}
					if(data.continue){
						this.total+=data.totales;
						this.no_seal+=data.no_sello;
						this.valid+=data.validas;
						this.complements+=data.complementos;
						this.complements_no_save+=data.complemento_no_save;
						this.complements_no_parent+=data.complemento_no_padre;
						this.saved+=data.guardadas;
						this.not_saved+=data.no_guardadas;
						this.no_xml+=data.no_xml;
						this.no_company+=data.no_company;
						this.no_provider+=data.no_provider;
					}
				} catch (error) {
					this.send = false;
					this.errors = {};
					if (error.response) {
						this.errors = await this.errorNotification(error);
					}
				} finally{
					i++;
				}
			}
			this.send=false;
			this.form.files = [];
			this.last();
        },
		async last() {
			this.load = true;
			let service = request;
			let _endpoint = '/last_uploaded_bill';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					// console.log(data);
					this.bill = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Cargar Facturas</h3>
				<br>
				<h3 class="card-title" v-if="bill.date_time">Última Carga {{ bill.date_time | toDateTimeHour }}</h3>
			</div>
			<div class="card-body">
				<form @submit.prevent="sendFiles" method="post" enctype="multipart/form-data">
					<div class="row">
						<div class="col-12">
							<hr>
							<div class="row">
								<div @dragover.prevent @drop.prevent class="col-12 text-center">
									<h3>Archivos adjuntos.</h3>
									<div @drop="dragFilesBill" class="row mt-4 mb-4">
										<div class="col-12" v-if="(form.files.length) == 0">
											<i class="fa-solid fa-file fa-4x"></i>
											<p>Sin archivos adjuntos</p>
										</div>
										<div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
											:key="index_img" v-show="form.files.length > 0">
											<div>
												<button class="btn btn-sm btn-danger del" type="button"
													@click="delImg(index_img)"><i class="fa fa-trash"></i></button>
													<p>{{ img.name }}</p>
											</div>
										</div>
									</div>


									<div class="input-group mb-3"
										v-if="(form.files.length) <= 14">
										<div class="custom-file" @change="uploadFilesBill">
											<input type="file" multiple class="custom-file-input" id="inputGroupFile03"
												aria-describedby="inputGroupFileAddon03">
											<label class="custom-file-label" for="inputGroupFile03">
												Subir Archivo
											</label>
										</div>
									</div>


								</div>

							</div>
						</div>
						<div class="col-md-12">
							<hr>
							<button :disabled="send" type="submit"
								class="btn float-right btn-outline-success">
								<span v-if="send">
									<i class="fa-solid fa-circle-notch fa-spin"></i> Procesando
								</span>
								<span v-else>
									<i class="fas fa-save"></i> Enviar
								</span>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
			<div v-if="total > 0">
				<div class="row">
					<div class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Procesadas</span>
								<span class="info-box-number">{{ total }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-upload"></i></span>
						</div>
					</div>
					<div v-if="saved > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Facturas Guardadas</span>
								<span class="info-box-number">{{ saved }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-download"></i></span>
						</div>
					</div>
					<div v-if="valid > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Conciliadas V&aacute;lidas</span>
								<span class="info-box-number">{{ valid }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-check-double"></i></span>
						</div>
					</div>
					<div v-if="complements > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Complementos de Pago</span>
								<span class="info-box-number">{{ complements }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-file-invoice-dollar"></i></span>
						</div>
					</div>
					<div v-if="no_seal > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Sin Sello</span>
								<span class="info-box-number">{{ no_seal }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-file-contract"></i></span>
						</div>
					</div>
					<div v-if="no_company > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Empresa no Encontrada</span>
								<span class="info-box-number">{{ no_company }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
						</div>
					</div>
					<div v-if="no_provider > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Proveedor no Encontrado</span>
								<span class="info-box-number">{{ no_provider }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
						</div>
					</div>
					<div v-if="complements_no_save > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Complementos No Guardados</span>
								<span class="info-box-number">{{ complements_no_save }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-hourglass-half"></i></span>
						</div>
					</div>
					<div v-if="complements_no_parent > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Complementos Sin Factura Padre</span>
								<span class="info-box-number">{{ complements_no_parent }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-hourglass-half"></i></span>
						</div>
					</div>
					<div v-if="not_saved > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Errores de Guardado</span>
								<span class="info-box-number">{{ not_saved }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
						</div>
					</div>
					<div v-if="no_xml > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
						<div class="info-box shadow-sm">
							<div class="info-box-content">
								<span class="info-box-text">Archivos No XML</span>
								<span class="info-box-number">{{ no_xml }}</span>
							</div>
							<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
						</div>
					</div>
				</div>
			</div>
		<ModalFormComponent/>
	</div>
</template>

<style scoped>
</style>
